import { CREDITS_ENDPOINTS } from './endpoints.js';
/**
 * Credits API Client
 * Encapsulates all credits-related API calls.
 */
export class CreditsClient {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * Get the current user's aggregated credit balance.
     * Corresponds to: GET /api/credits/balance
     */
    async getBalance() {
        const response = await this.httpClient.get(CREDITS_ENDPOINTS.GET_BALANCE);
        if (!response.success || !response.data) {
            throw new Error(response.error || 'Failed to get credit balance');
        }
        return response.data;
    }
    /**
     * Get the current user's model usage statistics.
     * Corresponds to: GET /api/credits/model-usage
     */
    async getModelUsageStats() {
        const response = await this.httpClient.get(CREDITS_ENDPOINTS.GET_MODEL_USAGE);
        if (!response.success || !response.data) {
            throw new Error(response.error || 'Failed to get model usage stats');
        }
        return response.data;
    }
    /**
     * Manually deduct credits from the current user's account.
     * Corresponds to: POST /api/credits/deduct
     * @note This is intended for developer debugging.
     */
    async deduct(request) {
        const response = await this.httpClient.post(CREDITS_ENDPOINTS.DEDUCT, request);
        if (!response.success || !response.data) {
            throw new Error(response.error || 'Failed to deduct credits');
        }
        return response.data;
    }
}
//# sourceMappingURL=client.js.map